import React from 'react';
// @mui
import { List } from '@mui/material';
import CompanyCategoryTile from './CompanyCategoryTile';

const CompanyCategoriesList = ({
  categories,
  onEdit,
  onDelete,
  disabled,
}) => {
  return (
    <List>
      {categories.map((item, index) => {
        const category = {
          id: item._id,
          name: item.name,
        };
        const isDisabled = disabled === category.id;

        return (
          <CompanyCategoryTile
            onEdit={id => onEdit(id)}
            onDelete={id => onDelete(id)}
            category={category}
            isDisabled={isDisabled}
            key={index}
          />
        );
      })}
    </List>
  );
};

export default CompanyCategoriesList;
